import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import MobileBottomBar from "./MobileBottomBar";
import AIChatbot from "./AIChatbot";
import RouteSeo from "./seo/RouteSeo";
const Layout = ({ children }: { children: React.ReactNode }) => {
  const { pathname } = useLocation();
  const isLandingPage = pathname.startsWith("/lp/") || pathname === "/thank-you";
  return (
    <div className="min-h-screen flex flex-col">
      <RouteSeo />
      <Header />
      <main className={`flex-1 ${isLandingPage ? "" : "pb-14 md:pb-0"}`}>{children}</main>
      <Footer />
      <WhatsAppButton />
      <AIChatbot />
      {!isLandingPage && <MobileBottomBar />}
    </div>
  );
};

export default Layout;
